import React from 'react'
import css from 'tfs.css-variables'
import injectSheet from 'react-jss'
import LoadingIcon from '../../components/LoadingIcon'

const styles = {
  loading: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '10rem',
    fontSize: '2rem',
    color: css.colorBlue,
  },
}

export default WrappedComponent =>
  injectSheet(styles)(
    props =>
      props.isFetching ? (
        <LoadingIcon className={props.classes.loading} />
      ) : (
        <WrappedComponent {...props} />
      )
  )
